<template>
    <page-message>
        <template #header>{{t('error', {code: code})}}</template>
        <template #message>{{message}}</template>
    </page-message>
</template>

<script>

    import mixinView from "@/mixins/view";
    import PageMessage from "@/components/page/PageMessage";

    export default {
        name: "ViewsErrorsCode",
        components: {
            PageMessage
        },
        mixins: [mixinView],
        data() {

            return {
                t_path: "views.errors.code"
            }
        },
        computed: {
            message() {

                if (this.$route.query.message) {

                    return this.$route.query.message;
                }

                return this.t('message');
            },
            code() {

                return this.$route.params.code;
            }
        }
    }
</script>